import { Injectable, Inject} from '@angular/core';


 export class SearchCriteriaDO {
  
    public paramName:any ; 

    public paramValue:any; 
    
    public getParamName(){
        return this.paramName;
    }

    public setParamName(paramName:any){
        this.paramName=paramName;
    }
    public getParamValue():any[]{
        return this.paramValue;
    }

    public setParamValue(paramValue:any[]){
        this.paramValue=paramValue;
    } 
	
}
